import axios from 'axios';

export default axios.create({
  baseURL: 'https://api.rubedyne.com/'
  //baseURL: 'https://cosahh-149311.ew.r.appspot.com/'
  // baseURL: 'http://localhost:8000/'
});